const Header = () => {
  return (
    <div
      className={`mb-10 h-[260px] bg-cover !bg-center max-w-2xl sm:h-[348px] overflow-hidden`}
      style={{
        backgroundImage: `url(https://cdn.firouzeh.com/public/progress-pma.png)`,
      }}
    >
      {/* <img
        // src={"https://cdn.firouzeh.com/public/bank-home-card-blue.png"}
        src={ProgressPma}
        className="m-auto max-w-[240px] relative  top-24"
        alt="PMA Progress"
      /> */}
    </div>
  );
};
export default Header;
